import { Flex, Spin } from 'antd';
import React, { type ReactNode } from 'react';

const SplashScreen = (): ReactNode => {
  return (
    <Flex align="center" justify="center" style={{ width: '100vw', height: '100vh' }}>
      <Spin />
    </Flex>
  );
};

export default SplashScreen;
